import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import store from "../stores/store";
import { logout } from "../slices/authSlice";

export const authMiddleware: Middleware = () => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
  if (isRejectedWithValue(action)) {
    const payload = action.payload as {
      status: number;
      data: { redirectUrl: string };
    };

    if (payload && payload.status === 401) {
      const redirectUrl = payload.data?.redirectUrl;
      if (redirectUrl) {
        store.dispatch(logout({ redirectUrl: redirectUrl }));
      }
    }
  }
  return next(action);
};
